import React from 'react';
import { useField } from 'formik';
import { FormFeedback, Label } from 'reactstrap';
import classNames from 'classnames';

const FieldWrapper = (props) => {
  const { name, label, fieldClassName, className, children } = props;
  const [field, meta] = useField(props);
  const hasError = meta.touched && !!meta?.error;

  return (
    <div className={classNames('field', className)} key={props?.key}>
      {!!label && <Label>{label}</Label>}
      <div
        className={classNames('form-field', fieldClassName, {
          'is-invalid': hasError,
        })}
      >
        {children}
      </div>
      {hasError && <FormFeedback type="invalid">{meta?.error}</FormFeedback>}
    </div>
  );
};

export default FieldWrapper;
